<template>
    <div v-if="body_show">
        <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>
        <!-- head -->
        <div class="ceping-head">
            <!-- 重测 -->
            <div class="reset-ceping">
                <img :src="data.headimgurl" />
                <div class="text">
                    <h3 class="text-ellipsis">{{data.nickname}}</h3>
                    <h4 class="text-ellipsis">{{data.ctime}}</h4>
                </div>
                <button class="restBtn on" @click="resetCeping()" v-if="data.past_days>=30">重新测评</button>
                <button class="restBtn" v-else>{{`${30-data.past_days} 天后可重测`}}</button>
            </div>
            <!-- 头部文字 -->
            <div class="head-text">
                <p>大部分的职场人都有多个角色，是老板、领导、员工，也是父母、孩子、丈夫或妻子，大家每天都要不停地切换自己不同的角色，试图做得完美，结果却往往不尽人意。</p>
                <p><span>其实生涯平衡是一个动态的平衡，所以应该要有纵向和横向的全局观。</span>纵向来看，在职业世界变化这么快的时代，至少要看到这个阶段和下一个阶段，才不会陷入到当前的状态去看生涯；横向来看，一个人在这个阶段有多少角色需要诠释。</p>
                <p><span>有了全局观之后，要找到每个阶段的重心。</span>重心不是按时间多少来算的，而是按对于一个人在这个阶段内心的重要程度来决定。在同样的阶段，每一个人的重心角色可能不一样。</p>
                <p> 一旦找到了<span>阶段重心</span>，要让自己更平衡，就要做到资源投入要跟重心角色保持一致。对于真正重要的事，再忙、再难也要确保为之做投入。</p>
            </div>
        </div>

        <!-- 测评结果 -->
        <div class="overall-main">
            <div class="overall-index">测评结果</div>
            <h2 class="h2">你的工作家庭平衡状态为： <br/><span class="em">{{data.report_key}}</span></h2>
            <h2 class="h2">测评得分结果：</h2>
            <!-- <canvas id="dimension" width="300" height="300"></canvas> -->
            <div id="dimension" class="dimension"></div>
            <div class="split"></div>
            <!-- <div class="subtitle">1.内心层面</div> -->
            <p class="text" v-html="data.report"></p>
        </div>
        <!-- 福利 -->
        <!-- <div class="overall-main pb">
            <div class="subtitle welfare">分享好友，听讲座</div> -->
            <!-- <img class="iverall-img" src="@a/c47_fuli.jpg">-->
            <!-- <p>
                <strong class="bold">想要获得更多平衡家庭与工作的策略</strong> <br>
                <strong class="bold">分享给三位好友（或微信群），免费听取专业讲座</strong> <br>
            </p>  -->
            <!-- <img  class="iverall-img" v-if="show_market"  src="@a/cp_share62_qrcode.png">
            <img  class="iverall-img" v-else  src="@a/cp_share62.png">
        </div> -->

        <!--更多测评 -->
<!--        <div class="overall-main pb">-->
<!--            <div class="subtitle welfare">更多测评</div>-->
<!--            <a class="toMeasurement" href="https://open.xjy.cn/main/measurement_list"> 点击查看我们的测评“全家桶”</a>-->
<!--        </div>-->

<!--        <public-ad-qrcode></public-ad-qrcode>-->

<!--        &lt;!&ndash; 关注二维码 &ndash;&gt;-->
<!--        <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">-->
<!--            <img v-if="is_main" class="qr-box" src="../../../assets/career_ceping47.jpg" />-->
<!--            <img v-else class="qr-box" src="../../../assets/coach_ceping47.jpg" />-->
<!--        </van-popup>-->

    </div>
</template>

<script>
import { ceping62_report,ceping62_reset } from "@/api/measurement";
import { shareCon,getNickName } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { getStorage, setStorage,isMain } from "@/utils/tools";
import { setTimeout } from 'timers';
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
    data(){
        return{
            body_show:false,
            data:{},
            show_market:false,
            type_obj: {
                evaluation_id: "",
                evaluation_name: "",
                evaluation_id: ""
            },
            isShow:false
        }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    computed: {
        is_main(){
            return isMain()
        }
    },
    mounted(){
        let path = this.$route.path;
        let show_market = getStorage(path, 'show_market62') || '';
        if(show_market == 'show') {
            this.show_market = true;
        }
    },
    methods:{
        // 重新测评
        resetCeping(){
            this.$dialog.confirm({
                title: '重新测评',
                message: '您确认要重测吗？'
            }).then(() => {
                ceping62_reset().then((data) => {
                    this.$router.push("/ceping62")
                })
                }).catch(() => {
                // on cancel
            });
            
        },
        set_show_market(){
            setStorage(this.$route.path, 'show_market62', 'show');
            this.show_market = true;
        },

        // 维度剖析
        dimension_chart(){
            let dimension = echarts.init(document.getElementById('dimension'));
            let dimension_indicator = [];
            let dimension_value = [];
            for (let key in this.data.self_result) {
                dimension_indicator.push({text: key, max: 4});
                dimension_value.push(this.data.self_result[key]);
            }
            let option = {
                color: ['#2780E0'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: Object.keys(this.data.self_result),
                        axisLabel : {//坐标轴刻度标签的相关设置。
                            interval:0,
                            rotate:"45"
                        },
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        // name: Object.keys(this.data.self_result),
                        type: 'bar',
                        barWidth: '60%',
                        data: dimension_value
                    }
                ]
            };

            // 为echarts对象加载数据
            dimension.setOption(option);
        },

        pullData() {
            ceping62_report({
                token:this.$route.query.token
            })
            .then((data) => {
                this.data = data;
                // replace(/(\r\n)|(\n)|(\r)/g,"</br>")替换所有回车;
                // 把文本中的回车换行替换成br标签
                // this.data.report = this.data.report.replace(/\n/g,"</br>");
                if (data.code != '10002') {
                    document.title = data.headtitle;
                    this.body_show = true;
                    // 给wxconfig传对象
                    this.type_obj.nickname = data.nickname;
                    this.type_obj.evaluation_id = data.report.cid;
                    this.type_obj.evaluation_name = data.headtitle;
                    this.type_obj.evaluation_user_id = String(data.uid);
                    this.type_obj.path = this.$route.path;

                    shareCon("ceping62", this, this.type_obj);


                    if(!data.subscribe && data.need_subscribe){
                        this.isShow = true;
                    }


                    setTimeout(()=>{
                        //
                        this.dimension_chart();
                    },1000);
                }else {
                    // 已经测评完成
                    this.$router.push({
                        path: '/ceping62',
                        query:{
                            cid:this.$route.query.cid
                        }
                    })
            }
            })
        }
    },
    created() {
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
    //头部介绍
    .ceping-head{
        margin-bottom: 30px;
        background: url(../../../assets/c47_banner.png) no-repeat top center;
        background-size: 100%;
        padding: 50px 30px 0 30px;
        .reset-ceping{
            display: flex;
            align-items: center;
            color: #fff;
            margin-bottom: 50px;
            img{
                width:100px;
                height: 100px;
                border-radius: 50%;
                margin-right: 30px;
            }
            .text h3,.text h4{
                width: 320px;
            }
            .restBtn{
                padding: 0 20px;
                line-height: 60px;
                border-radius: 12px;
                margin-left: auto;
                border: 0;
                background-color: #ccc;
            }
            .restBtn.on{
                background-color: #F57F17;
            }
        }
    }
    .head-text{
        padding: 50px 20px;
        background: #fff;
        border-radius: 8px;
        position: relative;
       
        p{
            font-size: 28px;
            line-height: 60px;
            text-align: justify;
            color: #333;
            font-weight: 400;
            padding-top: 20px;
            text-indent:2em;
            span{
                font-weight:bold;
                color:#2780E0;
            }
            span.on{
                text-indent:2em;
            }
        }
    }
    .head-text:before{
        content: '“';
        position: absolute;
        top: 30px;
        left: 10px;
        color: #2780E0;
        font-size: 82px;
        line-height: 82px;
        font-weight: 500;
    }
    .head-text:after{
        content: '”';
        position: absolute;
        bottom: -30px;
        right: 10px;
        color: #2780E0;
        font-size: 82px;
        line-height: 82px;
        font-weight: 500;
    }
    // 第一部分：自我分化总体指数
    .overall-main{
        margin: 0 30px 30px 30px;
        border-radius: 8px;
        background-color: #fff;
        text-align: center;
        padding: 50px 20px;
        .overall-index{
            display: inline-block;
            vertical-align: bottom;
            margin: 0 auto;
            color: #333;
            font-weight: 500;
            font-size: 36px;
            line-height: 38px;
            padding: 20px;
            border-top: 4px solid #2780E0;
            border-bottom: 4px solid #2780E0;
            margin-bottom: 50px;
            position: relative;
            
        }
        .overall-index:after{
            content:'';
            width: 0;
            height: 0;
            border-width: 30px 30px 0;
            border-style: solid;
            border-color: #2780E0 transparent transparent;
            position: absolute;
            bottom: -50px;
            left: 50%;
            transform: translateX(-50%);
        }
        // 仪表盘
        .dashboard{
            height: 400px;
            margin: 0 auto;
        }
        .h2{
            text-align: center;
            font-size: 28px;
            line-height: 48px;
            color: #333;
            font-weight: 400;
            padding-top: 20px;
            text-align: center;
            .em{
                color: #FB5717;
                font-size: 36px;
            }
        }
        .split{
            height: 1px;
            border-bottom: 1px dashed #2780E0;
            margin: 30px auto;
        }
        .tl{
            text-align: left;
        }
        .dimension{
            margin: 0 auto;
            height: 430px;
            margin: 30px auto;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
            position: relative;
        }
        .subtitle{
            display: inline-block;
            vertical-align: bottom;
            margin: 0 auto;
            width: auto;
            height: 60px;
            font-size: 26px;
            color: #fff;
            font-weight: 500;
            line-height: 30px;
            padding: 15px 60px;
            background: #2780E0;
            border-radius: 30px;
            position: relative;
        }
        .text{
            // font-size: 26px;
            // line-height: 48px;
            text-align: left;
            // color: #333;
            // font-weight: 400;
            // padding-top: 20px;
            .blue{
                color: #2780E0;
            }
        }
        .welfare{
            background: #FB5717;
            padding: 15px 75px;
        }
        .welfare:before{
            content: ' ';
            background: url(../../../assets/c47_icon.png) no-repeat center;
            background-size: 100%;
            width: 44px;
            height: 60px;
            position: absolute;
            top: 50%;
            left: -60px;
            transform: translateY(-50%);
        }
        .welfare:after{
            content: ' ';
            background: url(../../../assets/c47_icon.png) no-repeat center;
            background-size: 100%;
            width: 44px;
            height: 60px;
            position: absolute;
            top: 50%;
            right: -60px;
            transform: translateY(-50%);
        }
        // 福利
        .iverall-img{
            width: 100%;
            margin: 50px auto 30px;
        }
        p{
            line-height: 48px;
            text-align: center;
            color: #333;
            padding-top: 20px;
            .bold{
                font-size: 32px;
                line-height: 40px;
                color: #2780E0;
            }
        }
        .poster-abs{
            margin: 0 auto;
            position: relative;
            img{
                position: absolute;
                left:50px;
                bottom: 50px;
                width: 100px;
                height: 100px;
            }
            span{
                position: absolute;
                left: 170px;
                bottom: 50px;
                font-size: 25px;
                line-height: 38px;
                color: #333;
                text-align: left;
            }
        }
        .toMeasurement{
            color: #333;
            display: block;
            font-size: 26px;
            text-align: left;
            line-height: 48px;
            padding: 15px;
            text-decoration: underline;
        }
    }
    .pb{
        padding-bottom: 0;
    }
    .effect{
        width: 100%;
        max-width: 750px;
        margin-top: 30px;
    }
    .small-title{
        font-size: 34px;
        font-weight: bold;
        color: #333;
        background-color: #fff;
        padding:30px;
        margin: 0 30px 30px 30px;
        border-radius:8px;
    }
    .qr-box{
        width:600px;
    }
</style>
<style>
    .editor-text p,.editor-text strong,.editor-text span{
        text-align: left !important;
        padding-top: 10px !important;
        font-size: 26px !important;
        font-weight: normal !important;
        line-height: 48px !important;
        font-family: sans-serif !important;
    }
</style>
